export type SemanticType = 'success' | 'warning' | 'danger' | 'info' | 'confirmation';

export interface SemanticStyle {
  bg: string;
  color: string;
  icon: string;
}

export const SEMANTIC_STYLES: Record<SemanticType, SemanticStyle> = {
  success: { bg: '#E1FCDE', color: '#10B981', icon: 'fi-ss-check-circle' },
  warning: { bg: '#FFF2D2', color: '#B45309', icon: 'fi-ss-triangle-warning' },
  danger: { bg: '#FFE4E6', color: '#DC2626', icon: 'fi-ss-cross-circle' },
  info: { bg: '#E0EDFF', color: '#0C66E4', icon: 'fi-ss-info' },
  confirmation: { bg: '#FFF2D2', color: '#B45309', icon: 'fi-ss-interrogation' },
};
